export enum LangCodes {
    english = 'en',
    spanish = 'es',
  }
  